
<div class="Tabs">
    <div class="Tabs-Header" role="tablist">
        <button
            v-for="tab in resolvedTabs"
            :key="tab.key"
            class="Tabs-Tab"
            :class="{ 'is-active': tab.key === internalActive }"
            role="tab"
            :aria-selected="tab.key === internalActive"
            :aria-controls="`panel-${tab.key}`"
            @click="selectTab(tab.key)"
        >
            <i v-if="tab.icon" :class="`ri-${tab.icon}-line Tabs-Icon`"></i>
            <span class="Tabs-Label">{{ tab.label }}</span>
            <span
                v-if="tab.badge !== undefined"
                class="Tabs-Badge"
                :class="tab.badgeClass || 'is-basic'"
            >
                {{ tab.badge }}
            </span>
        </button>
    </div>
    <div class="Tabs-Content">
        <slot :active="internalActive"></slot>
    </div>
</div>
